import { ReactElement } from 'react';

/**
 * TeamsTab management Page.
 * @returns - A Teams tab management component.
 */
export default function TeamsTab(): ReactElement {
  return (
    <div className="bg-container-500 rounded flex flex-1 justify-center items-center text-6xl font-bold text-white my-4">
      Coming soon
    </div>
  );
}
